// (function ($) {
//   $(document).ready(function () {

//     $('.ishicategoryblock').each(function () {
//       var $section = $(this);
//       var sectionId = $section.data('ishi-section-id');
//       var doRedirect = (String($section.data('redirect')) === 'true');
//       var $carousel = $section.find('.ishicategoryblock-carousel-' + sectionId);

//       // Init OwlCarousel
//       if ($carousel.length && typeof $carousel.owlCarousel === 'function') {
//         $carousel.owlCarousel({
//           nav: false,
//           dots: false,
//           margin: 30,
//           loop: true,
//           rtl: $('body').hasClass('lang-rtl'),
//           autoplay: false,
//           responsive: {
//             0: { items: 1 },
//             544: { items: 2 },
//             768: { items: 3 },
//             992: { items: 3 },
//             1200: { items: 5 },
//             1500: { items: 5 }
//           }
//         });
//       }

//       // Click handler simplified (no query params)
//       $section.on('click', '.ishicategoryblock-carousel-' + sectionId + ' a', function (e) {
//         var $a = $(this);
//         var href = $a.attr('href') || '';

//         if (!href || href.indexOf('javascript:') === 0 || href === '#') return;

//         var newUrl = href;

//         // Handle new tab clicks normally
//         var isNewTab = e.metaKey || e.ctrlKey || e.shiftKey || (e.which === 2) || ($a.attr('target') === '_blank');
//         if (isNewTab) {
//           $a.attr('href', newUrl);
//           return;
//         }

//         if (doRedirect) {
//           e.preventDefault();
//           window.location.assign(newUrl);
//         }

//         // Active class toggle
//         $section.find('.ishicategoryblock-carousel-' + sectionId + ' a').removeClass('active');
//         $a.addClass('active');
//       });
//     });
//   });
// })(jQuery);


document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".ishicategoryblock").forEach(section => {
    const sectionId = section.dataset.ishiSectionId;
    const doRedirect = String(section.dataset.redirect) === "true";
    const carouselEl = section.querySelector(".ishicategoryblock-carousel-" + sectionId);
    if (!carouselEl) return;

    console.log("carousel test");

    // RTL support
    if (document.body.classList.contains("lang-rtl")) {
      carouselEl.setAttribute("dir", "rtl");
    }

    // Initialize Swiper
    if (typeof Swiper !== "undefined") {
      const swiper = new Swiper(carouselEl, {
        slidesPerView: "auto",  // Let slide width determine visible count
        loop: false,
        freeMode: true,         // allows smooth drag scrolling
        grabCursor: true,       // shows grab cursor
        watchOverflow: true,
        observer: true,
        observeParents: true,
      });

      // Recalculate after images load (for lazyload)
      carouselEl.querySelectorAll("img").forEach(img => {
        if (!img.complete) img.addEventListener("load", () => swiper.update());
      });
    }

    // Handle link click
    section.addEventListener("click", e => {
      const link = e.target.closest(`.ishicategoryblock-carousel-${sectionId} a`);
      if (!link) return;

      const href = link.getAttribute("href") || "";
      if (!href || href.startsWith("javascript:") || href === "#") return;

      const isNewTab =
        e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1 || link.getAttribute("target") === "_blank";
      if (isNewTab) return;

      if (doRedirect) {
        e.preventDefault();
        window.location.assign(href);
      }

      section.querySelectorAll(`.ishicategoryblock-carousel-${sectionId} a`).forEach(a => a.classList.remove("active"));
      link.classList.add("active");
    });
  });
});


